import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Modal, Dropdown, DropdownButton } from "react-bootstrap";
import '../componentCss/webform.css';
import '../componentCss/sidebar.css';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from "./sidebar";
import Dashboardheader from "./dashboardheader";
import {getMedpassPrescriptionListAction, getDashboardStatisticsAction, getInitiateRecordStatusAction, initiateDrugAction, recordDrugAction, getDrugHistoryAction } from '../../Action/admin.action';
import { Link, useParams } from 'react-router-dom';
import config from '../../config/config';
import { decryptData } from './decrypt';
import propertise, { reportsFileds } from '../../config/properties';
import DataTable from 'react-data-table-component';
import toast from 'react-hot-toast';
const moment = require('moment');


const AdministrativePage = () => {
    let { id, mrnNumber } = useParams();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [medPassDrugAssignedList, setMedPassDrugAssignedList] = useState([]);
    const [buttonStates, setButtonStates] = useState({});
    const [statistics, setStatistics] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState(""); // "initiate" or "record"
    const [selectedRow, setSelectedRow] = useState(null);
    const [remarks, setRemarks] = useState(""); // used for both modes
    const [customDatetime, setCustomDatetime] = useState("");
    const [historyData, setHistoryData] = useState([]);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedRx, setSelectedRx] = useState(null);
    const [showRxModel, setShowRxModel] = useState(false);




    
    useEffect(() => {
        getMedpassPrescriptionListActionAPI()
        
    }, []);
    

    const getMedpassPrescriptionListActionAPI = async () => {
        const medPassDrugData = await getMedpassPrescriptionListAction({ mrnNumber: mrnNumber }) // pass argument page : administrative if need to be fetch all the Records
        let data = decryptData(medPassDrugData?.data);
        const now = moment();
        
        const updated_data = data.map(record => {
            const start = moment(`${record.rxStartDate} ${record.rxStartTime}`, "YYYY-MM-DD HH:mm");
            const end = moment(`${record.rxCutDate} ${record.rxCutTime}`, "YYYY-MM-DD HH:mm");
            let current_status = 'upcoming';
            if (end.isBefore(now)) {
                current_status = 'miss';
            } else if (now.isBetween(start, end, null, '[)')) {
                current_status = 'running';
            }

            return {
                ...record,
                current_status
            };
        });
        setMedPassDrugAssignedList(updated_data);
        // 💡 Call button status fetch here
        fetchInitiateRecordStatuses(updated_data);
    }

    const fetchInitiateRecordStatuses = async (drugList) => {
      const states = {};
      for (const row of drugList) {
        const status = await getInitiateRecordStatusAction(row.id);
        states[row.id] = status.status; // "no_entry", "initiated", or "recorded"
      }
      setButtonStates(states);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page - 1);
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
    };

    const handleInitiateClick = (row) => {
      setModalMode("initiate");
      setSelectedRow(row);
      setRemarks("");
      setShowModal(true);
      setCustomDatetime("");
      // open modal to initiate
    };

    const handleRecordClick = (row) => {
      setModalMode("record");
      setSelectedRow(row);
      setRemarks("");
      setShowModal(true);
      setCustomDatetime("");
      // open modal to record
    };

    const handleViewDetails = (drugData) => {
      try {
      if (drugData.rxData) {
        const parsedRxData = JSON.parse(drugData.rxData);
        const selectedRxItem = JSON.parse(parsedRxData).find(item => item.id === drugData.drugId);

        setSelectedRx(selectedRxItem);
        setShowRxModel(true);
      }
    } catch (error) {
    }
    };

    const handleViewHistory = async (prescriptionId) => {
      const res = await getDrugHistoryAction({ prescription_id: prescriptionId });
      if (res.success) {
        setHistoryData(res.data);
        setShowHistoryModal(true);
      } else {
        toast.error("Failed to fetch history");
      }
    };


    const handleModalConfirm = async () => {
      if (!selectedRow || !customDatetime) {
        toast.error("Please provide valid datetime.");
        return;
      }

      if (modalMode === "initiate") {
        const payload = {
          prescription_id: selectedRow.id,
          physician_name: selectedRow.physicianname,
          drugName: selectedRow.drugName,
          drugCode: selectedRow.drugCode,
          rxStartDate: selectedRow.rxStartDate,
          rxStartTime: selectedRow.rxStartTime,
          rxCutDate: selectedRow.rxCutDate,
          rxCutTime: selectedRow.rxCutTime,
          dosagetype: selectedRow.dosagetype,
          dosagequantity: selectedRow.dosagequantity,
          units: selectedRow.units,
          initiate_remarks: remarks,
          initiate_date_time: customDatetime,
        };

        const res = await initiateDrugAction(payload);
        if (res.success) toast.success("Initiated successfully");
        else toast.error("Initiation failed");

      } else if (modalMode === "record") {
        const lastCycle = await getInitiateRecordStatusAction(selectedRow.id);

        if (!lastCycle?.latest_initiate_time) {
          toast.error("Cannot record without an initiate record.");
          return;
        }

        // ⛔ Validate that record datetime > initiate datetime
        if (new Date(customDatetime) <= new Date(lastCycle.latest_initiate_time)) {
          toast.error("Record time must be after initiate time.");
          return;
        }

        const payload = {
          prescription_id: selectedRow.id,
          record_comment: remarks,
          record_datetime: customDatetime,
          cycle: lastCycle.cycle
        };

        const res = await recordDrugAction(payload);
        if (res.success) toast.success("Recorded successfully");
        else toast.error("Record failed");
      }

      setShowModal(false);
      await getMedpassPrescriptionListActionAPI(); // Refresh UI
    };


      

    const columns = [
        {
          name: '#',
          cell: (row, index) => index + 1 + currentPage * rowsPerPage,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
        },
        {
          name: 'Physician Name',
          selector: row => row.physicianname,
          width: "17%"
        },
        {
            name: 'Current Status',
            selector: row => row.current_status,
            width: "17%"
        },
        {
          name: 'Drug Name',
          selector: row => row.drugName,
          sortable: true,
          width: "17%"
        },
        {
          name: 'Drug Code',
          selector: row => row.drugCode,
          width: "17%"
        },
        {
          name: 'Rx Start/Cut Datetime',
          selector: row => (
            <>
              {moment(row.rxStartDate).format("DD/MM/YYYY")} {moment(row.rxStartTime, 'HH:mm').format('hh:mm A')} - {moment(row.rxCutDate).format("DD/MM/YYYY")} {moment(row.rxCutTime, 'HH:mm').format('hh:mm A')}
            </>
          ),
          width: "35%"
        },
        {
          name: 'Dosage Type',
          selector: row => row.dosagetype,
          width: "15%"
        },
        {
          name: 'Dosage Quantity',
          selector: row => row.dosagequantity,
          width: "15%"
        },
        {
          name: 'Units',
          selector: row => row.units,
          width: "10%"
        },
        {
          name: 'Status',
          selector: row => (
            <span className={row.status == 1 ? "text-success fw-bold" : "text-danger fw-bold"}>
              {row.status == 1 ? "Running" : "Stopped"}
            </span>
          )
        }
      ];

    


    return (
  <div id="content" >
    
    <Dashboardheader />
    <div className="d-flex">
    {/* ✅ Sidebar Goes Here */}
    <Sidebar />

    {/* ✅ Main Content */}
    <div className="flex-grow-1">
      <Container fluid className="p-4">

        {/* Your header */}
        <Row>
          <Col md={6} sm={6} className="mb-3">
            <h5 className="headtitle">Administrative Page</h5>
          </Col>
        </Row>

        {/* Card Grid */}
        {medPassDrugAssignedList?.length > 0 && (
          <Row className="text-center mb-4">
            {medPassDrugAssignedList.map((field, index) => (
              <Col md={4} sm={6} key={index}>
                <Card className="statistic-card">
                  <Card.Body>
                    <Card.Title>{field.drugName || 'Data'}</Card.Title>
                    <Card.Text className="count">
                      {field.current_status}
                    </Card.Text>
                    <div className="d-flex flex-wrap gap-2 justify-content-center mt-2">
                      {(buttonStates[field.id] === "no_entry" || buttonStates[field.id] === "recorded") && (
                        <Button variant="danger" onClick={() => handleInitiateClick(field)}>Initiate</Button>
                      )}
                      {buttonStates[field.id] === "initiated" && (
                        <Button variant="primary" onClick={() => handleRecordClick(field)}>Record</Button>
                      )}
                      <Button variant="info" onClick={() => handleViewDetails(field)}>View Details</Button>
                      <Button variant="secondary" onClick={() => handleViewHistory(field.id)}>View History</Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* DataTable */}
        {medPassDrugAssignedList?.length > 0 ? (
          <DataTable
            columns={columns}
            data={medPassDrugAssignedList}
            pagination
            paginationPerPage={rowsPerPage}
            paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: 'Row per page:',
              rangeSeparatorText: 'out of',
            }}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        ) : (
          <div className="text-center">No Data Found</div>
        )}

        {/* Modal for Initiate/Record */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>{modalMode === "initiate" ? "Initiate Drug" : "Record Drug"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control as="textarea" rows={3} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{modalMode === "initiate" ? "Initiate Time" : "Record Time"}</Form.Label>
                <Form.Control type="datetime-local" value={customDatetime} onChange={(e) => setCustomDatetime(e.target.value)} />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleModalConfirm}>Confirm</Button>
            </Modal.Footer>
          </Modal>



        {/* History Modal */}
          <Modal show={showHistoryModal} onHide={() => setShowHistoryModal(false)} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>Drug History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {historyData.length > 0 ? (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Cycle</th>
                      <th>Initiate Time</th>
                      <th>Initiate Remarks</th>
                      <th>Record Time</th>
                      <th>Record Comment</th>
                      {/* <th>Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {historyData.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.cycle}</td>
                        <td>{row.initiate_date_time || "-"}</td>
                        <td>{row.initiate_remarks || "-"}</td>
                        <td>{row.record_datetime || "-"}</td>
                        <td>{row.record_comment || "-"}</td>
                        {/* <td>{row.current_status}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-center">No history found.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowHistoryModal(false)}>Close</Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for Rx Details */}
                <Modal show={showRxModel} onHide={() => setShowRxModel(false)} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title className="text-primary fw-bold">Rx Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {selectedRx ? (
                      <div className="container">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <p><strong className="text-secondary">Drug Code:</strong> {selectedRx.drugcode || 'NA'}</p>
                          </div>
                          <div className="col-md-6">
                            <p><strong className="text-secondary">Package Name:</strong> {selectedRx.packagename || 'NA'}</p>
                          </div>
                        </div>
          
                        <div className="card shadow-sm p-3">
                          <h5 className="text-primary border-bottom pb-2">Prescription Details</h5>
                          <ul className="list-unstyled mt-3">
                            {Object.entries(selectedRx.rxData).map(([key, value], index) => (
                              <li key={index} className="d-flex">
                                <span className="text-secondary fw-bold col-5">{key}:</span>
                                <span className="text-dark col-7">{value}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center text-danger">No details available.</p>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRxModel(false)}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
          
      </Container>
    </div>
  </div>
  </div>
);

};

export default AdministrativePage;
